const { getAxiosInstance } = require('../connection');

module.exports = {
    SaveNote: function (note, eventId, userId, organizationId, orderId) {
        return getAxiosInstance({
            url:  '/note',
            method: 'POST',
            json: true,
            data: {
                note: note,
                eventId: eventId,
                userId: userId,
                organizationId: organizationId,
                orderId: orderId,
            },
        }).then((r) => r.data);
    },
    GetNote: function (eventId = '', userId = '', organizationId = '', orderId = '') {
        const params =
            'eventId=' + encodeURIComponent(eventId) + '&userId=' + encodeURIComponent(userId) + '&organizationId=' + encodeURIComponent(organizationId) + '&orderId=' + encodeURIComponent(orderId);
        return getAxiosInstance({
            url:  '/note?' + params,
            method: 'GET',
            json: true,
        }).then((r) => r.data);
    },
    ExportNotes: function (eventId = '', userId = '', organizationId = '', orderId = '', excel = false, excelObject = {}) {
        const params =
            'eventId=' +
            encodeURIComponent(eventId) +
            '&userId=' +
            encodeURIComponent(userId) +
            '&organizationId=' +
            encodeURIComponent(organizationId) +
            '&orderId=' +
            encodeURIComponent(orderId) +
            '&excel=' +
            encodeURIComponent(excel) +
            '&excelObject=' +
            encodeURIComponent(JSON.stringify(excelObject));
        return getAxiosInstance({
            url:  '/note?' + params,
            method: 'GET',
            responseType: 'blob',
            json: true,
        }).then((r) => r.data);
    },
    NoteSubjectOptions: function () {
        return getAxiosInstance({
            url:  '/note/subject-options',
            method: 'GET',
        }).then((r) => r.data);
    },
};
